import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      "item": item.href ? `https://qinqinmanga.com${item.href}` : undefined,
    })),
  };

  const categoryMap: Record<string, string> = {};
  categories.forEach((cat) => {
    categoryMap[cat.slug] = cat.name;
  });

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbJsonLd)}
      </script>
      <nav aria-label="面包屑导航" className="w-full py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <span className="text-foreground-300 mx-1">/</span>
                )}
                {!isLast && item.href ? (
                  <Link
                    to={item.href}
                    className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className={`whitespace-nowrap ${isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}`}>
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}